import { render, staticRenderFns } from "./addSigningRules.vue?vue&type=template&id=45ecc1bd&scoped=true&"
import script from "./addSigningRules.vue?vue&type=script&lang=js&"
export * from "./addSigningRules.vue?vue&type=script&lang=js&"
import style0 from "./addSigningRules.vue?vue&type=style&index=0&id=45ecc1bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ecc1bd",
  null
  
)

export default component.exports